<template>
  <LoadingBlock :loading="loading">
    <div class="card">
      <div class="card-body">
        <p class="text-muted mb-4">
          Система найдёт товары без действующего сертификата и попытается автоматически привязать
          подходящий сертификат по совпадению бренда, категории или названия.
          Задача обрабатывает все подходящие товары, а не только одну страницу списка.
        </p>

        <form @submit.prevent="submit">
          <div class="row gy-3">
            <div class="col-md-6">
              <label class="form-label">Бренд</label>
              <input type="text" class="form-control" v-model="filters.brand" placeholder="Например, Bosch">
            </div>
            <div class="col-md-6">
              <label class="form-label">Название</label>
              <input type="text" class="form-control" v-model="filters.name" placeholder="Поиск по названию">
            </div>
            <div class="col-md-12">
              <label class="form-label">Конкретные товары</label>
              <MultiSelect
                  v-model="filters.product_ids"
                  :options="productOptions"
                  optionLabel="label"
                  optionValue="id"
                  filter
                  placeholder="Выберите товары (необязательно)"
                  style="width: 100%"
                  @filter="onProductFilter"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label">Статус товара</label>
              <Select v-model="disabledFilter" :options="disabledOptions" optionLabel="name"
                      optionValue="code" placeholder="Все товары" showClear style="width: 100%"/>
            </div>
            <div class="col-md-6 d-flex align-items-end">
              <div class="form-check mb-2">
                <input class="form-check-input" type="checkbox" id="in-stock" v-model="filters.in_stock">
                <label class="form-check-label" for="in-stock">Только в наличии</label>
              </div>
            </div>
          </div>

          <div class="mt-4">
            <ButtonComponent ref="submitButton" class="btn btn-primary" @click="submit">
              Запустить сопоставление
            </ButtonComponent>
          </div>
        </form>
      </div>
    </div>
  </LoadingBlock>
</template>

<script>
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import ButtonComponent from "@/components/tools/Button.vue";
import {MultiSelect, Select} from "primevue";
import {autoLink} from "@/api/certificate";
import {getProducts} from "@/api/product";
import {user} from "@/data/user";
import {Message, Messages} from "@/data/messages";
import {parseCertificateError} from "@/data/certificate";
import {afterStoreAction} from "@/helpers/store";

export default {
  name: "CertificateAutoLink",
  components: {LoadingBlock, ButtonComponent, MultiSelect, Select},
  data() {
    return {
      loading: false,
      filters: {
        brand: '',
        name: '',
        product_ids: [],
        in_stock: false,
      },
      disabledFilter: null,
      disabledOptions: [
        {name: 'Активные', code: 'false'},
        {name: 'Скрытые', code: 'true'},
      ],
      productOptions: [],
      filterTimeout: null,
    }
  },
  methods: {
    buildPayload() {
      const payload = {
        company: user.active_company,
      }
      if (this.filters.brand) {
        payload.brand = this.filters.brand
      }
      if (this.filters.name) {
        payload.name = this.filters.name
      }
      if (this.filters.product_ids?.length) {
        payload.product_ids = this.filters.product_ids
      }
      if (this.disabledFilter !== null && this.disabledFilter !== '') {
        payload.disabled = this.disabledFilter === 'true'
      }
      if (this.filters.in_stock) {
        payload.in_stock = true
      }
      return payload
    },
    onProductFilter(event) {
      clearTimeout(this.filterTimeout)
      this.filterTimeout = setTimeout(() => {
        this.searchProducts(event.value)
      }, 300)
    },
    async searchProducts(name = '') {
      const query = {size: 50}
      if (name) {
        query.name = name
      }
      if (this.filters.brand) {
        query.brand = this.filters.brand
      }
      const result = await getProducts(user.active_company, query)
      this.productOptions = (result.data.items || []).map((product) => ({
        id: product.id,
        label: product.name,
      }))
    },
    async submit() {
      this.$refs.submitButton.startLoading()
      const message = new Message()
      try {
        const result = await autoLink(this.buildPayload())
        if (result.status === 202 || result.status === 200) {
          if (result.data?.info || result.data?.error || result.data?.warning) {
            afterStoreAction(result)
          } else {
            message.type = 'success'
            message.autoremove = 15
            message.text = 'Задача сопоставления запущена. Прогресс можно отслеживать в разделе «Задачи».'
            Messages.list.push(message)
          }
        } else {
          afterStoreAction(result)
        }
      } catch (e) {
        message.type = 'failure'
        message.text = parseCertificateError(e)
        Messages.list.push(message)
      }
      this.$refs.submitButton.endLoading()
    },
  },
  async mounted() {
    await this.searchProducts()
  },
}
</script>
